import moment from 'moment';
import { setPhoneNumber } from './TicketsHelper';

export const validationBodyGenerator = (body) => {
  const { orderId, sku } = body;
  return {
    description: ' ',
    order_id: String(orderId),
    sale_date: ' ',
    shipped_date: ' ',
    sku: sku,
    status: ' ',
    type: ' ',
  };
};

export const successCounterInState = (innerState) => {
  let successes = 0;
  const successesToReach = Object.keys(innerState).length;
  Object.keys(innerState).forEach((input) => {
    if (innerState[input].success || !innerState[input].required)
      successes += 1;
  });
  if (successes === successesToReach) return true;
  return false;
};

export const dispatchGenerator = (innerState, name, validationBody) => {
  const { newValue, error, errorMessage, helperText } = validationBody;
  return {
    field: name,
    value: {
      value: newValue,
      error: error !== undefined ? error : innerState[name].error,
      message: errorMessage || innerState[name].message,
      helper: helperText || innerState[name].helper,
      inputAdornment: innerState[name].inputAdornment,
      label: innerState[name].label,
      success: error !== undefined ? !error : innerState[name].success,
      textArea: innerState[name].textArea,
      disabled: innerState[name].disabled,
      required: innerState[name].required,
    },
  };
};

export const parseIdWithHyphen = (id) =>
  id.substring(0, id.length - 1) + '-' + id.substring(id.length - 1);

export const genericSelfServiceBody = ({
  product,
  profile,
  type,
  validation,
}) => ({
  cud: validation.cud,
  rut: parseIdWithHyphen(profile.logonId).toLowerCase(),
  name: profile.firstName + ' ' + profile.lastName,
  quantity: product.quantity,
  productName: product.name,
  price: product.price,
  email: profile.email1,
  imageUrl: product.thumbnailImage,
  phone: setPhoneNumber(profile),
  type: type,
  oc: product.orderId.toString(),
  sku: product.dispatch.lines[0].product_sku || product.sku,
  purchaseDate: moment(product.purchaseDate, 'YYYY-MM-DD HH:mm:ss.S').format(
    'YYYY-MM-DD',
  ),
  myAccount: true,
  source: product.source,
});

export const messageSelfServiceMapper = new Map([
  ['28', 'Tercero autorizado para poder retirar producto'],
  ['29', 'Tu número de solicitud es'],
  ['10', 'Nueva dirección de entrega'],
  ['1', 'Nueva fecha de entrega'],
]);
